// Registry of floor-plan gesture TOOLS — the per-frame bodies behind the
// sidebar's Select / Wall / Measure tools. Unlike the model editor's
// event-driven tools (app/tool-registry), floor tools are POLLED: every desktop
// frame, floor-mode computes the shared frame inputs (cursor floor point +
// the once-consumed press/release edges) and hands the ACTIVE tool its frame.
// Exactly one tool runs per frame (floorTool is a single value), so there is
// no claim ordering; a tool's internal press-priority chain is its own concern.
//
// E2 seam (see ARCHITECTURE.md): bodies register from inside floor-mode's
// closure today; E3+ lifts them into floor/tools/ slices one at a time without
// touching this dispatch again.

import { type FloorTool as FloorToolId } from "../ui/floor-ui";

export interface FloorFrame {
  fp: { x: number; z: number } | null; // cursor on the floor plane (null in side views)
  press: boolean; // LMB went down this frame (already consumed from the mouse seam)
  release: boolean; // LMB came up this frame
  // The wall corner under the cursor — computed by the shared hover preamble
  // (which also drives the corner markers). Select-tool-only; null otherwise.
  hoverVid: number | null;
}

export interface FloorGestureTool {
  id: FloorToolId;
  frame(f: FloorFrame): void; // the tool's whole per-frame body while active
}

export interface FloorToolRegistry {
  register(tool: FloorGestureTool): void;
  frame(id: FloorToolId, f: FloorFrame): void; // run the active tool's frame
}

export function createFloorToolRegistry(): FloorToolRegistry {
  const tools = new Map<FloorToolId, FloorGestureTool>();
  return {
    register(tool): void {
      tools.set(tool.id, tool);
    },
    frame(id, f): void {
      tools.get(id)?.frame(f);
    },
  };
}
